import { useGomakeTheme } from "@/hooks/use-gomake-thme";
import { adaptPaddingRight } from "@/utils/adapter";
import { FONT_FAMILY } from "@/utils/font-family";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import type { ResetPasswordStrength } from "@/utils/reset-password-policy";

const useStyle = (strength: ResetPasswordStrength = "weak") => {
  const { theme, primaryColor, errorColor, successColor, neutralColor } =
    useGomakeTheme();
  const { t } = useTranslation();

  const strengthColor = useMemo(() => {
    if (strength === "strong") return successColor(500);
    if (strength === "medium") return primaryColor(500);
    return errorColor(500);
  }, [strength, successColor, primaryColor, errorColor]);

  const clasess = useMemo(() => {
    return {
      leftContainer: {
        display: "flex",
        flexDirection: "column" as "column",
        justifyContent: "center" as "center",
        alignItems: "center",
        height: "100%",
        minHeight: "100vh",
        width: "50%"
      },
      logoContainer: {
        display: "flex",
      },
      loginContainer: {
        alignItems: "flex-start",
        width: "100%",
        ...adaptPaddingRight(t("direction"), 48),
        marginTop:40
        // paddingLeft: 48,
      },
      loginLbl: {
        color: primaryColor(600),
        ...FONT_FAMILY.Outfit(600, 48),
        marginBottom: 40,
      },
      descriptionLbl: {
        ...FONT_FAMILY.Lexend(400, 14),
        color: primaryColor(600),
        marginBottom: 30,
        textAlign: "center" as "center",
      },
      inputContainer: {
        display: "flex",
        flexDirection: "column" as "column",
        gap: 16,
      },
      inputLbl: {
        color: primaryColor(900),
        ...FONT_FAMILY.Lexend(600, 20),
      },
      input: {
        width: "85%",
        marginBottom: 15
      },
      btnContainer: {
        width: "50%",
        display: "flex",
        justifyContent: "flex-end",
        alignItems: "flex-end",
        alignSelf: "flex-end",
        marginTop: 30,
      },
      forgotStyle:{
        display: "flex",
       marginTop:10,
       cursor:"pointer",
      },
      errorMsgStyle:{
        ...FONT_FAMILY.Lexend(500,12),
        color:errorColor(500),
        marginTop:10,
      },
      strengthSection: {
        marginTop: 8,
        marginBottom: 8,
        width: "85%",
      },
      strengthLabel: {
        ...FONT_FAMILY.Lexend(500, 13),
        color: primaryColor(700),
        marginBottom: 6,
      },
      strengthBarTrack: {
        height: 6,
        borderRadius: 4,
        backgroundColor: neutralColor(200),
        overflow: "hidden" as const,
      },
      strengthBarFill: {
        height: "100%",
        borderRadius: 4,
        transition: "width 0.2s ease, background-color 0.2s ease",
      },
      requirementsList: {
        listStyle: "none",
        padding: 0,
        margin: "8px 0 16px",
        width: "85%",
        display: "flex",
        flexDirection: "column" as const,
        gap: 6,
      },
      requirementItem: {
        display: "flex",
        alignItems: "center",
        gap: 8,
      },
      requirementMet: {
        ...FONT_FAMILY.Lexend(400, 13),
        color: primaryColor(700),
      },
      requirementUnmet: {
        ...FONT_FAMILY.Lexend(400, 13),
        color: neutralColor(600),
      },
      requirementIconMuted: neutralColor(400),
      recaptchaContainer: {
        marginTop: 8,
        marginBottom: 8,
      },
      successDialogBody: {
        display: "flex",
        flexDirection: "column" as const,
        alignItems: "center",
        textAlign: "center" as const,
        paddingBlock: 12,
        paddingInline: 16,
        gap: 20,
      },
      successIconCircle: {
        width: 88,
        height: 88,
        borderRadius: "50%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: successColor(100),
        boxShadow: "0 10px 28px rgba(15, 23, 42, 0.08)",
      },
      successMessage: {
        ...FONT_FAMILY.Lexend(400, 16),
        color: primaryColor(700),
        lineHeight: 1.5,
        maxWidth: 320,
      },
    };
  }, [theme, t, primaryColor, errorColor, successColor, neutralColor]);
  return {
    clasess,
    successIconColor: successColor(500),
    strengthColor,
  };
};
export { useStyle };
